import { useRef } from 'react';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const sortedComics = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 260;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 gap-4">
            <div className="flex items-center gap-4">
              <span className="px-4 py-1.5 border border-background-400/20 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                最新更新
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 font-heading">
                韩国漫画大全
              </h2>
            </div>
            <div className="hidden md:flex items-center gap-2">
              <button
                type="button"
                onClick={() => scroll('left')}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:bg-background-50 hover:text-foreground-950 hover:border-background-50 transition-all cursor-pointer"
                aria-label="向左滚动"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                type="button"
                onClick={() => scroll('right')}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-950 hover:bg-background-200 transition-all cursor-pointer"
                aria-label="向右滚动"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {sortedComics.map((comic) => (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                category={comic.category}
                cover={comic.cover}
                rating={comic.rating}
                hot={comic.hot}
                status={comic.status}
                chapters={comic.chapters}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}